import { PropsWithChildren, FC } from 'react';

import { Card } from '@hh.ru/magritte-ui-card';
import { Text } from '@hh.ru/magritte-ui-typography';

export const MobileDelimiter: FC<PropsWithChildren> = ({ children }) => {
    return (
        <Card padding={16} paddingTop={8} paddingBottom={0} stretched>
            <Text typography="label-3-regular" style="secondary">
                {children}
            </Text>
        </Card>
    );
};
